import { genericPost } from './apiService';
import { API_URL } from '../config/env';

/**
 * Destek formu gönder
 * @param {Object} request - Form verileri
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const AddSupportFormReq = async (request) => {
  try {
    const response = await genericPost(`${API_URL}SupportForm/Add`, request);
    return response;
  } catch (error) {
    throw error;
  }
}; 